var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3"},[_c('h6',[_vm._v(_vm._s(_vm.options.label))]),_c('vue-dropzone',_vm._g(_vm._b({ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-complete":_vm.afterUploadComplete}},'vue-dropzone',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }